export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_imayo-studio/artifacts/rlrx0yss_MAIN_LOGO_IMD.svg";

export const WHATSAPP_NUMBER = "34621078618"; // España (+34) 621 078 618

const _waUrl = (msg) =>
  `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=${encodeURIComponent(msg)}`;

/**
 * Build a WhatsApp click-to-chat URL with a context-specific pre-filled message.
 * Pass the language ('es' | 'ca') and an optional intent key to pick the right copy.
 */
export const buildWhatsAppUrl = (intent = "default", lang = "es", extra = "") => {
  const messages = {
    es: {
      default: "Hola, me gustaría pedir cita en Iñaki Mayo Dental.",
      first_visit: "Hola, me gustaría reservar mi primera visita gratuita.",
      info: "Hola, me gustaría más información sobre vuestros tratamientos.",
      contact: "Hola, quisiera hablar con vosotros sobre mi caso.",
      treatment: `Hola, me gustaría más información sobre ${extra}.`,
      promotion: `Hola, me interesa la promoción "${extra}".`,
      jobs: "Hola, me gustaría enviar mi candidatura para trabajar con vosotros.",
    },
    ca: {
      default: "Hola, m'agradaria demanar cita a Iñaki Mayo Dental.",
      first_visit: "Hola, m'agradaria reservar la meva primera visita gratuïta.",
      info: "Hola, m'agradaria més informació sobre els vostres tractaments.",
      contact: "Hola, voldria parlar amb vosaltres sobre el meu cas.",
      treatment: `Hola, m'agradaria més informació sobre ${extra}.`,
      promotion: `Hola, m'interessa la promoció "${extra}".`,
      jobs: "Hola, m'agradaria enviar la meva candidatura per treballar amb vosaltres.",
    },
  };
  const dict = messages[lang] || messages.es;
  const msg = dict[intent] || dict.default;
  return _waUrl(msg);
};

// Default link kept for backward compatibility (used where context isn't relevant)
export const WHATSAPP_URL = buildWhatsAppUrl("default", "es");

export const PHONE = "934 090 407";
export const PHONE_TEL = "tel:+34934090407";
export const WHATSAPP_DISPLAY = "621 078 618";

export const CLINIC_ADDRESS = "Av. Catalunya, 24 · 08290 Cerdanyola del Vallès · Barcelona";
export const CLINIC_ADDRESS_LINES = "Av. Catalunya, 24\n08290 Cerdanyola del Vallès\nBarcelona";

export const INSTAGRAM_URL = "https://instagram.com/imayodental_cerdanyola";
export const INSTAGRAM_HANDLE = "@imayodental_cerdanyola";

// Public-facing email shown on the website
export const CONTACT_EMAIL = "recepcion@imayodental.es";
// Internal email used by Resend to receive form submissions (testing)
export const FORM_RECIPIENT_EMAIL = "c.sarmiento@element-dental.com";

export const MAPS_EMBED =
  "https://www.google.com/maps?q=Av.%20Catalunya%2024%2C%2008290%20Cerdanyola%20del%20Vall%C3%A8s%2C%20Barcelona&output=embed";

export const INVISALIGN_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_imayo-studio/artifacts/zzy5ifrv_Aleph%202_0%20-%20Invisalign%20horizontal_1.aleph%202_0%20-%20invisalign%20horizontal_1_1.mp4";

export const IMPLANTS_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_imayo-studio/artifacts/8a30wtxx_Aleph%202_0%20-%20implantes%20COMP.aleph%202_0%20-%20implantes%20comp.mp4";

export const DESIGN_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_imayo-studio/artifacts/t5ok1y0r_disen%CC%83o%20de%20sonrisa.mp4";

export const KIDS_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_imayo-studio/artifacts/3bttlnog_mayo%20kids.mp4";

export const PERIO_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_imayo-studio/artifacts/1d32aakb_Periodontitis%20horizontal_1.mp4";

export const ENDO_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_imayo-studio/artifacts/ky1181a5_Endodonsia%20swaped%20colores.mov";

export const PROTHESIS_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_imayo-studio/artifacts/0v4hfkz8_conceptual-3d-animation-of-a-dental-bridge-2026-01-28-05-24-15-utc.mp4";

export const TREATMENT_VIDEOS = {
  invisalign: INVISALIGN_VIDEO_URL,
  implants: IMPLANTS_VIDEO_URL,
  design: DESIGN_VIDEO_URL,
  kids: KIDS_VIDEO_URL,
  perio: PERIO_VIDEO_URL,
  endo: ENDO_VIDEO_URL,
  prothesis: PROTHESIS_VIDEO_URL,
};

export const IMAGES = {
  heroBg:
    "https://images.pexels.com/photos/33685863/pexels-photo-33685863.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  clinicInterior:
    "https://customer-assets.emergentagent.com/job_imayo-studio/artifacts/glujepxk_CLINICA%20DENTAL%20MAYO-17-2.jpg",
  doctor:
    "https://customer-assets.emergentagent.com/job_imayo-studio/artifacts/glujepxk_CLINICA%20DENTAL%20MAYO-17-2.jpg",
  doctorPortrait:
    "https://customer-assets.emergentagent.com/job_imayo-studio/artifacts/r34rmnhg_IN%CC%83AKIENPIJAMA%20Large.png",
  smile1:
    "https://images.pexels.com/photos/4554000/pexels-photo-4554000.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  smile2:
    "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
  invisalign:
    "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?auto=format&fit=crop&w=1200&q=80",
  implants:
    "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?auto=format&fit=crop&w=1200&q=80",
  design:
    "https://images.unsplash.com/photo-1581585504970-f74e4c8f4f48?auto=format&fit=crop&w=1200&q=80",
  kids:
    "https://images.unsplash.com/photo-1607619056574-7b8d3ee536b2?auto=format&fit=crop&w=1200&q=80",
  perio:
    "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&w=1200&q=80",
  aesthetic:
    "https://images.unsplash.com/photo-1629909613654-28e377c37b09?auto=format&fit=crop&w=1200&q=80",
  facade:
    "https://images.unsplash.com/photo-1629909615184-74f495363b67?auto=format&fit=crop&w=1400&q=80",
};
